<template>
  <div>
    <div class="buttons-wrapper mb-3">
      <div>
        <CButton
          class="mb-1"
          size="sm"
          color="primary"
          :disabled="isSelectionEmpty"
          @click="showResetModal = true"
        >
          Réinitialiser la sélection
        </CButton>
      </div>
      <div>
        <CButton
          class="mb-1"
          size="sm"
          style="background-color: #1131ae; color: white"
          :disabled="isSelectionEmpty"
          @click="
            () =>
              processFile(
                ALUMNI_ENDPOINTS.rapport_export,
                this.buildRapportPayload(),
                '',
                'Export en cours des données séléctionnées',
                ''
              )
          "
        >
          Exporter les données
        </CButton>
      </div>
      <FileDragdrop @upload="importData">
        <template slot="upload-button">
          <CButton
            class="mb-1"
            size="sm"
            color="primary"
            :disabled="!!loadingMessage.length"
          >
            Importer un fichier complété manuellement
          </CButton>
        </template>
      </FileDragdrop>
      <div>
        <CButton
          class="mb-1"
          size="sm"
          color="primary"
          :disabled="isSelectionEmpty"
          @click="
            () =>
              processFile(
                ALUMNI_ENDPOINTS.fiche6,
                this.buildRapportPayload(),
                'Error: something went wrong',
                'Traitement en cours',
                'Analyses réalisées avec succès'
              )
          "
        >
          Lancer l'analyse
        </CButton>
      </div>
      <div>
        <CButton
          class="mb-1"
          size="sm"
          style="background-color: #1131ae; color: white"
          :disabled="isSelectionEmpty"
          @click="
            () =>
              processFile(
                ALUMNI_ENDPOINTS.fiche7,
                this.buildRapportPayload(),
                'No Alumni with post diplome duration equal to 6M or > 24M',
                'Traitement en cours',
                'Tableaux de promotion générés avec succès'
              )
          "
        >
          Générer les tableaux de promotion
        </CButton>
      </div>
    </div>
    <div
      v-if="loadingMessage.length"
      class="d-flex justify-content-center w-100 mt-3"
    >
      <div class="d-flex justify-content-between align-items-center gap-3">
        <h3>{{ loadingMessage }}</h3>
        <dots-loader />
      </div>
    </div>
    <div class="d-flex flex-column justify-content-center mt-5 gap-4">
      <SelectionRow
        select-title="Sélectionner un type de diplôme / formation :"
        selected-title="Sélection des certifications:"
        :available-options="availableCertificationTypes"
        :selected="selectedCerts"
        @selection="fetchCerts"
        @removeSelection="(val) => remove(selectedCerts, val)"
      >
        <template slot="center">
          <div class="d-flex flex-column">
            <h5 class="text-muted">Ajouter un élément:</h5>
            <MzSelect
              searchable
              allow-unselect
              :multiple="true"
              class="w-100"
              :disabled="!selectedCertificationType"
              :options="availableCerts"
              @update:value="(val) => addSelection(selectedCerts, certsData, val)"
            />
          </div>
        </template>
        <template slot="selectionName" slot-scope="{ selection }">
          {{certNames[selection]}}
        </template>
      </SelectionRow>
      <SelectionRow
        select-title="Sélectionner une école :"
        selected-title="Sélection des écoles (UC):"
        :available-options="availableEcoleOptions"
        :selected="selectedEcoles"
        :disableSelect="!selectedCerts.length"
        @selection="(val) => addSelection(selectedEcoles, ecolesData, val)"
        @removeSelection="(val) => remove(selectedEcoles, val)"
      >
        <template slot="center">
          <div class="d-flex flex-column">
          </div>
        </template>
        <template slot="selectionName" slot-scope="{ selection }">
          {{ecoleNames[selection]}}
        </template>
      </SelectionRow>
      <SelectionRow
        select-title="Sélectionner une promotion :"
        selected-title="Sélection des promotions:"
        :available-options="availablePromotionOptions"
        :selected="selectedPromotions"
        :disableSelect="!selectedCerts.length"
        @selection="(val) => addSelection(selectedPromotions, promotionsData, val)"
        @removeSelection="(val) => remove(selectedPromotions, val)"
      >
        <template slot="center">
          <div class="d-flex flex-column">
          </div>
        </template>
        <template slot="selectionName" slot-scope="{ selection }">
          {{promotionNames[selection]}}
        </template>
      </SelectionRow>
    </div>
    <CModal
      :show.sync="showResetModal"
      :draggable="false"
      :resizable="false"
      centered
    >
      <template slot="header-wrapper"><span></span></template>
      La sélection en cours va etre supprimée
      <template slot="footer">
        <div>
          <CButton
            color="secondary"
            class="mr-2"
            @click="showResetModal = false"
          >
            Annuler
          </CButton>
          <CButton color="primary" @click="resetSelection"> Valider </CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import {CertService} from "@/services/certification";
import { ALUMNI_ENDPOINTS, AlumniService } from "@/services/alumni";
import { FilesService } from "@/services/files";
import Task from "@/services/task";
import SelectionRow from "@/components/SelectionRow";

export default {
  name: "Rapport",
  components: {SelectionRow},
  data() {
    return {
      ALUMNI_ENDPOINTS,
      availableCertificationTypes: [],
      selectedCertificationType: null,
      certsData: [],
      ecolesData: [],
      promotionsData: [],
      allCertsData: [],
      allEcolesData: [],
      allPromotionsData: [],
      selectedCerts: [],
      selectedEcoles: [],
      selectedPromotions: [],
      fetchSequence: 0,
      loadingMessage: "",
      showResetModal: false,
      messageMapper: {
        "columns in the template not found":
          "Expected columns missing in template F7",
        "extra columns in data":
          "Unexpected columns found in template F7",
      },
      fichier6Message: {
        info: "Traitement en cours ...",
        success: "Analyse injectée dans la base de données",
        error: "Error: somthing went wrong",
      },
    };
  },
  computed: {
    availableCerts() {
      return this.filteredOptions(this.certsData, this.selectedCerts);
    },
    availableEcoleOptions() {
      return this.filteredOptions(this.ecolesData, this.selectedEcoles);
    },
    availablePromotionOptions() {
      return this.filteredOptions(this.promotionsData, this.selectedPromotions);
    },
    isSelectionEmpty() {
      return !this.selectedCerts.length;
    },
    certNames() {
      return Object.fromEntries(
        this.allCertsData.map((certData) => {
          return [certData.value, certData.label];
        })
      );
    },
    ecoleNames() {
      return Object.fromEntries(
          this.allEcolesData.map((ecoleData) => {
            return [ecoleData.value, ecoleData.label];
          })
      );
    },
    promotionNames() {
      return Object.fromEntries(
          this.allPromotionsData.map((promotionsData) => {
            return [promotionsData.value, promotionsData.label];
          })
      );
    },
    selectedCertFilterCodes() {
      return this.selectedCerts.length
        ? this.selectedCerts
        : this.certsData.map((cert) => cert.value);
    },
    rapportPayloadDefaults() {
      return {
        certification_codes: this.selectedCertFilterCodes,
        ecoles_ls: this.selectedEcoles,
        promotions_ls: this.selectedPromotions,
      };
    }
  },
  watch: {
    selectedCerts() {
      if (!this.selectedCerts.length) {
        this.selectedEcoles = [];
        this.selectedPromotions = [];
      }
      this.fetchSequence++;
      const seq = this.fetchSequence;
      this.fetchEcoles(seq);
      this.fetchPromotions(seq);
    }
  },
  async mounted() {
    await this.fetchCerts('all', true);
    await this.fetchData();
    this.allCertsData = [...this.certsData];
    this.allEcolesData = [...this.ecolesData];
    this.allPromotionsData = [...this.promotionsData];
    await this.fetchOptions();
  },
  methods: {
    filteredOptions(data, selected) {
      const options = (Array.isArray(data) ? data : []).filter(
        (item) => !selected.includes(item.value)
      );
      return [{ label: "All", value: "All" }, ...options];
    },
    async fetchData() {
      if (!this.selectedCerts.length) {
        this.ecolesData = [];
        this.promotionsData = [];
      } else {
        await this.fetchEcoles();
        await this.fetchPromotions();
      }
    },
    async fetchOptions() {
      await this.fetchCertTypes();
    },
    async fetchCertTypes() {
      const types = await CertService.getTypes(true)
      this.availableCertificationTypes = [
        {
          label: "Tout sélectionner",
          value: "all"
        },
        ...types,
        {
          label: "Aucun type",
          value: "empty"
        },
      ]
    },
    async processFile(url, body, errorMessage, infoMessage, successMessage) {
      const method = "POST";

      if (infoMessage.length) {
        this.loadingMessage = infoMessage;
      }

      const { res, data } = await request({
        url,
        method,
        body,
      });

      if (res.status !== 200) {
        this.loadingMessage = "";
        return alert(errorMessage);
      }
      let showProgress = true;

      const taskId = data.task_id;
      if (taskId) {
        const new_task = new Task(taskId);
        new_task.on("progress", (data) => {
          if(data?.progress === 50 && showProgress) {
            alert(successMessage)
            showProgress = false;
          }
        });
        new_task.on("result", (result) => {
          this.loadingMessage = "";
          if (Array.isArray(result)) {
            const notInjectedCount = result[0];
            return alert(
              `WARNING: Les résultats de ${notInjectedCount} URLs n'ont pas été injectés correctement en BD`
            );
          }
          if (url === ALUMNI_ENDPOINTS.fiche7 && result?.check_format) {
            if (!result.check_format.Status) {
              Object.entries(result.check_format).forEach(
                ([messageText, messageDetails]) => {
                  if (messageText !== 'Status') {
                    const errorText = this.messageMapper?.[messageText] || messageText;
                    const errorDetails = Array.isArray(messageDetails)
                      ? messageDetails.join(", ")
                      : messageDetails;
                    alert(`${errorText}: ${errorDetails}`);
                  }
                }
              );
              return;
            }
            if (result.exception) {
              alert(`Error: ${result.exception}`);
              return;
            }
          }
          if (result?.exception) {
            return alert("Problème de génération de données");
          }
          AlumniService.downloadFiche6(result.filename);

          if (url !== ALUMNI_ENDPOINTS.fiche6)
            return alert(successMessage);

          if (showProgress) {
            alert(successMessage);
          }
          alert("Analyses injectées avec succès pour tous les URLs");

        });
        new_task.on("error", (error) => {
          const message = error?.exception || error?.result?.check_format?.Error || "Something went wrong";
          alert(`Error: ${message}`);
        });
      }
    },
    buildRapportPayload() {
      return {
        ...this.rapportPayloadDefaults,
        promotions_ls: (this.selectedPromotions || []).map((promotion) =>
          Number(promotion)
        ),
      };
    },
    addSelection(selection, data, value) {
      if (selection.indexOf(value) === -1) {
        if (value === "All") {
          selection.push(
            ...(Array.isArray(data) ? data : [])
              .filter((cert) => !selection.includes(cert.value))
              .map((cert) => cert.value)
          );
        } else {
          selection.push(value);
        }
      }
    },
    async fetchCerts(type, initial=false) {
      const { data } = await request({
        url: ALUMNI_ENDPOINTS.certs(type),
      });
      this.certsData = data.map((certData) => {
        return {
          label: certData.certification_name,
          value: certData.certification_code,
        };
      });
      this.allCertsData = [...this.certsData];
      if (!initial) {
        this.selectedCertificationType = type;
        this.selectedCerts = [];
        this.selectedEcoles = [];
        this.selectedPromotions = [];
      }
    },
    async fetchEcoles(seq) {
      if (!this.selectedCerts.length) {
        this.ecolesData = [];
        this.selectedEcoles = [];
        return;
      }
      const ecoles = await AlumniService.getEcoleOptions({
        certification_codes: this.selectedCerts,
      });
      if (seq != null && seq !== this.fetchSequence) return;
      this.ecolesData = (ecoles || []).map((ecole) => ({
        label: ecole,
        value: ecole,
      }));
      this.allEcolesData = [...this.ecolesData];
      if (this.selectedEcoles.length) {
        const availableValues = this.ecolesData.map((item) => item.value);
        this.selectedEcoles = this.selectedEcoles.filter((selection) =>
          availableValues.includes(selection)
        );
      }
    },
    async fetchPromotions(seq) {
      if (!this.selectedCerts.length) {
        this.promotionsData = [];
        this.selectedPromotions = [];
        return;
      }
      const promotions = await AlumniService.getPromotionOptions({
        certification_codes: this.selectedCerts,
      });
      if (seq != null && seq !== this.fetchSequence) return;
      this.promotionsData = (promotions || []).map((promotion) => ({
        label: `${promotion}`,
        value: `${promotion}`,
      }));
      this.allPromotionsData = [...this.promotionsData];
      if (this.selectedPromotions.length) {
        const availableValues = this.promotionsData.map((item) => item.value);
        this.selectedPromotions = this.selectedPromotions.filter((selection) =>
          availableValues.includes(selection)
        );
      }
    },
    remove(selected, value) {
      const index = selected.indexOf(value);
      if (index === -1) {
        return;
      }
      selected.splice(index, 1);
    },
    async resetSelection() {
      this.selectedCerts = [];
      this.selectedEcoles = [];
      this.selectedPromotions = [];
      this.selectedCertificationType = null;
      this.showResetModal = false;
    },
    async importData(files) {
      this.loadingMessage = 'Traitement en cours'
      await FilesService.uploadFile({
        file: files[0],
        url: ALUMNI_ENDPOINTS.manuel_upload,
        onError: (response) => {
          this.loadingMessage = ''
          return alert(response.detail);
        },
        onSuccess: () => {
          this.loadingMessage = ''
          alert("Fichier importé avec succès");
        }
      });
    },
  },
};
</script>

<style lang="scss">
.toasted {
  width: fit-content !important;
}
.toasted-container {
  align-items: center !important;
}
</style>
